import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/task-list-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-4ce85c9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "float-end cursor-pointer z-index-99 position-relative d-flex"
}
const _hoisted_2 = {
  key: 0,
  class: "me-2 module-status align-items-center"
}
const _hoisted_3 = {
  key: 1,
  class: "me-2 module-status align-items-center"
}
const _hoisted_4 = { class: "title-description-wrapper show-gradient" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "actions-wrapper d-flex" }
const _hoisted_8 = { class: "actions d-flex align-items-center" }
const _hoisted_9 = {
  key: 0,
  class: "new-task me-2 cursor-pointer"
}
const _hoisted_10 = {
  key: 1,
  class: "task-list-btn cursor-pointer d-flex align-items-center ps-2 pe-2 me-2"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  src: _imports_0,
  alt: "task-list-icon"
}, null, -1))
const _hoisted_12 = { class: "progress-line2" }
const _hoisted_13 = {
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#moduleDoneWithTasks",
  ref: "openModal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feather_icon = _resolveComponent("feather-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-wrapper", {
    'external': _ctx.model.internExtern === 'EXTERN',
  }])
  }, [
    (_ctx.isRolledOut)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.status === 'PAUSED')
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "paused"))
            : _createCommentVNode("", true),
          (_ctx.status === 'PENDING')
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "not started"))
            : _createCommentVNode("", true),
          (_ctx.status === 'ACTIVE' || _ctx.status === 'DONE')
            ? (_openBlock(), _createBlock(_component_feather_icon, {
                key: 2,
                type: "check-circle",
                size: "20",
                stroke: _ctx.status === 'DONE' ? '#2eb868' : '#9ea8b7',
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.changeModuleStatus('DONE')), ["stop"])),
                class: "me-2",
                title: "Mark as done"
              }, null, 8, ["stroke"]))
            : _createCommentVNode("", true),
          (_ctx.status === 'PENDING' || _ctx.status === 'PAUSED')
            ? (_openBlock(), _createBlock(_component_feather_icon, {
                key: 3,
                type: "play-circle",
                size: "20",
                stroke: "#FF0000",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.changeModuleStatus('ACTIVE')), ["stop"])),
                title: _ctx.status === 'PENDING' ? 'Start module' : 'Resume module'
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          (_ctx.status === 'ACTIVE')
            ? (_openBlock(), _createBlock(_component_feather_icon, {
                key: 4,
                type: "pause-circle",
                size: "20",
                stroke: "#FF8C00",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.changeModuleStatus('PAUSED')), ["stop"])),
                title: "Pause module"
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass({ done: _ctx.status === 'DONE' || _ctx.status === 'PENDING' || _ctx.status === 'PAUSED' }),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo()))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.model.title), 1),
        _createElementVNode("p", {
          class: "description m-0",
          innerHTML: _ctx.model.description
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, " NEW "))
            : _createCommentVNode("", true),
          (_ctx.totalModuleItems)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("span", null, _toDisplayString(_ctx.totalModuleItems), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.subProcessTag)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "task-list-btn cursor-pointer d-flex align-items-center ps-2 pe-2 me-2",
                style: _normalizeStyle({ backgroundColor: _ctx.generateRandomColor(_ctx.subProcessTag) })
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.subProcessTag), 1)
              ], 4))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createBlock(_component_feather_icon, {
                key: 3,
                type: "more-horizontal",
                size: "16",
                stroke: "#1F3245"
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subTasksStats.STATUS?.DONE, (index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item done",
            key: index,
            style: _normalizeStyle(`width:${100 / _ctx.totalModuleItems}%`)
          }, null, 4))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subTasksStats.STATUS?.STUCKED, (index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item stucked",
            key: index,
            style: _normalizeStyle(`width:${100 / _ctx.totalModuleItems}%`)
          }, null, 4))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subTasksStats.STATUS?.IN_PROGRESS, (index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item in-progress",
            key: index,
            style: _normalizeStyle(`width:${100 / _ctx.totalModuleItems}%`)
          }, null, 4))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subTasksStats.STATUS?.TODO, (index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: index,
            style: _normalizeStyle(`width:${100 / _ctx.totalModuleItems}%`)
          }, null, 4))
        }), 128))
      ])
    ], 2),
    _withDirectives(_createElementVNode("button", _hoisted_13, "Open", 512), [
      [_vShow, false]
    ])
  ], 2))
}